import { z } from 'zod'

import { isoDateTime } from '../lib/date'

export const orderAllocationSchema = z.object({
  id: z.uuid(),
  orderId: z.uuid(),
  stockId: z.uuid(),
  /** Units allocated from this stock row */
  quantity: z.number(),
  /** Set when the allocation is reversed — stock is incremented back. Null = active. */
  reversedAt: isoDateTime.nullable(),
  createdAt: isoDateTime,
})

export type OrderAllocation = z.output<typeof orderAllocationSchema>
